const UINT32_MAX = 4294967295;
const MINT_GAS_LIMIT_MULTIPLIER = 1.2;
const NULL_ADDRESS = "0x0000000000000000000000000000000000000000";
const MINT_FALLBACK_GAS_LIMIT = 200000n;

export { MINT_FALLBACK_GAS_LIMIT, MINT_GAS_LIMIT_MULTIPLIER, NULL_ADDRESS, UINT32_MAX };
